import Marquee from "react-fast-marquee";
import { Diamond } from "lucide-react";

const ITEMS = ["Menu Digitali", "Soluzioni NFC", "Siti Web", "Fotografia", "Video & Drone", "Recensioni Google"];

const EditorialMarquee = () => (
  <div data-testid="editorial-marquee" className="border-y border-[#C19D60]/10 bg-[#080809] py-7">
    <Marquee speed={28} gradient={false} pauseOnHover>
      {ITEMS.map((item) => (
        <span key={item} className="mx-10 flex items-center gap-10">
          <span className="font-display text-2xl font-light italic tracking-wide text-[#F8F5F0]/60">{item}</span>
          <Diamond size={10} className="fill-[#C19D60]/50 text-[#C19D60]/50" />
        </span>
      ))}
    </Marquee>
  </div>
);

export default EditorialMarquee;
